import { render, staticRenderFns } from "./ChatContentHeader.vue?vue&type=template&id=f1dfbac0&scoped=true"
import script from "./ChatContentHeader.vue?vue&type=script&lang=ts"
export * from "./ChatContentHeader.vue?vue&type=script&lang=ts"
import style0 from "./ChatContentHeader.vue?vue&type=style&index=0&id=f1dfbac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dfbac0",
  null
  
)

export default component.exports